import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

function Login() {
    const [err, setErr] = useState(null);
    const login = localStorage.getItem("user");
    const [profile, setProfile] = useState(null);
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        setError,
        formState: { errors }
    } = useForm();

    useEffect(() => {
        if (login) {
            navigate("/");
        }
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile !== res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []);

    const onSubmit = async (data) => {
        const regex = /^[a-zA-Z0-9]+$/;
        if (data.username.length < 6) {
            setError("username", {
                type: "minLength",
                message: "Tên đăng nhập tối thiểu 6 kí tự"
            });
            return;
        }
        if (!regex.test(data.username)) {
            setError("username", {
                type: "minLength",
                message: "Tên đăng nhập không chứa khoảng trắng và ký tự đặc biệt"
            });
            return;
        }
        if (data.password.length < 6) {
            setError("password", {
                type: "minLength",
                message: "Mật khẩu tối thiểu 6 kí tự"
            });
            return;
        }
        axios
            .post(`${process.env.REACT_APP_API_URL}/auth/login`, {
                username: data.username.toLowerCase(),
                password: data.password
            })
            .then((res) => {
                swal({
                    title: "Thông báo",
                    text: "Đăng nhập thành công",
                    icon: "success",
                    buttons: "OK"
                }).then(() => {
                    localStorage.removeItem("user");
                    localStorage.removeItem("profile");
                    localStorage.removeItem("data");
                    localStorage.setItem("user", res.data.data);
                    window.location.href = "/";
                });
            })
            .catch((err) => setErr(err.response?.data?.message ? err.response.data.message : "Tên đăng nhập hoặc mật khẩu không chính xác!"));
    };

    const [showPassword, setShowPassword] = useState(false);
    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    return (
        <>
            <style>
                {`
                /* TOÀN BỘ TRANG & VIDEO NỀN */
                .login-wrapper {
                    position: fixed; 
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    font-family: Arial, sans-serif;
                    z-index: 99999; 
                    overflow-y: auto; 
                    background-color: #000;
                }
                .bg-video {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    object-fit: cover;
                    z-index: -2;
                }
                .bg-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    background: rgba(0, 0, 0, 0.25); 
                    z-index: -1;
                }

                /* CĂN GIỮA KHUNG ĐĂNG NHẬP */
                .login-content {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    min-height: 100vh;
                    padding: 20px;
                    box-sizing: border-box;
                }
                .login-box {
                    width: 100%;
                    max-width: 340px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }

                /* LOGO HỆ THỐNG */
                .login-logo {
                    width: 200px;
                    height: auto;
                    margin-bottom: 25px;
                    object-fit: contain;
                    cursor: pointer; /* Thêm con trỏ bàn tay khi hover */
                    transition: transform 0.2s ease;
                }
                .login-logo:hover {
                    transform: scale(1.05); /* Hiệu ứng phóng to nhẹ khi hover */
                }

                /* THIẾT KẾ Ô NHẬP LIỆU */
                .input-row {
                    width: 100%;
                    margin-bottom: 14px;
                    position: relative;
                }
                .input-control {
                    width: 100%;
                    height: 42px;
                    border-radius: 25px;
                    background-color: rgba(255, 255, 255, 0.22);
                    border: 1px solid rgba(255, 255, 255, 0.45);
                    padding: 0 45px 0 20px;
                    font-size: 14px;
                    color: #fff;
                    box-sizing: border-box;
                    outline: none;
                    backdrop-filter: blur(5px);
                    -webkit-backdrop-filter: blur(5px);
                    transition: all 0.3s ease;
                }
                .input-control:focus {
                    background-color: rgba(255, 255, 255, 0.35);
                    border-color: rgba(255, 255, 255, 0.9);
                }
                .input-control::placeholder {
                    color: rgba(255, 255, 255, 0.85);
                    font-size: 13px;
                }
                .eye-btn {
                    position: absolute;
                    right: 16px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: rgba(255, 255, 255, 0.85);
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                }

                /* CHECKBOX */
                .remember-row {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    margin-bottom: 18px;
                    padding-left: 5px;
                }
                .remember-me {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    color: #fff;
                    font-size: 13px;
                    cursor: pointer;
                    user-select: none;
                }
                .remember-me input {
                    accent-color: #00e5ff;
                    cursor: pointer;
                    width: 14px;
                    height: 14px;
                }

                /* NHÓM NÚT BẤM */
                .action-buttons {
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                    width: 100%;
                }
                .btn-submit {
                    width: 100%;
                    height: 42px;
                    border-radius: 25px;
                    background: linear-gradient(90deg, #3bc6ff 0%, #007eff 100%);
                    border: none;
                    color: #fff;
                    font-weight: bold;
                    font-size: 15px;
                    cursor: pointer;
                    box-shadow: 0 4px 12px rgba(0, 126, 255, 0.35);
                    transition: background 0.3s ease, opacity 0.2s;
                }
                .btn-submit:hover {
                    opacity: 0.92;
                }
                
                /* NÚT ĐĂNG KÝ (Nền trong suốt, viền xanh) */
                .btn-register {
                    width: 100%;
                    height: 42px;
                    border-radius: 25px;
                    background: rgba(255, 255, 255, 0.1);
                    border: 1.5px solid #3bc6ff;
                    color: #fff;
                    font-weight: bold;
                    font-size: 15px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    backdrop-filter: blur(5px);
                }
                .btn-register:hover {
                    background: rgba(59, 198, 255, 0.2);
                }

                /* BANNER 1.1.1.1 */
                .banner-1111 {
                    width: 100%;
                    max-width: 240px;
                    margin-top: 25px;
                    border-radius: 8px;
                    cursor: pointer;
                    transition: transform 0.2s ease;
                }
                .banner-1111:hover {
                    transform: scale(1.03);
                }

                /* LỖI */
                .error-msg {
                    color: #ff4d4d;
                    font-size: 12px;
                    margin-top: 4px;
                    margin-left: 12px;
                    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.6);
                    font-weight: 500;
                }  /* LINK ĐĂNG NHẬP */
                .login-link {
                    text-align: center;
                    margin-top: 15px;
                    font-size: 13px;
                    color: rgba(255, 255, 255, 0.8);
                }
                .login-link span {
                    color: #00e5ff;
                    cursor: pointer;
                    text-decoration: underline;
                    font-weight: bold;
                    transition: color 0.2s ease;
                }
                .login-link span:hover {
                    color: #fff;
                }
                `}
            </style>

            <div className="login-wrapper">
                <video autoPlay loop muted playsInline className="bg-video">
                    <source src="https://www.sv368cpc1.tv/res/media/user-page-bg.9ea9f08.mp4" type="video/mp4" />
                </video>
                <div className="bg-overlay"></div>

                <div className="login-content">
                    <div className="login-box">
                        
                        {/* 1. Thêm sự kiện onClick để chuyển về Home (/) */}
                        <img
                            src="https://i.ibb.co/RptZzQzN/wps-Logo-BIA66-Gold-3-20251106133142.png" 
                            alt="SV368" 
                            className="login-logo" 
                            style={{ backgroundImage: 'url(https://i.ibb.co/your-logo-url-if-any.png)', height: '55px' }} 
                            onClick={() => navigate("/")}
                        />

                        <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
                            <div className="input-row">
                                <input 
                                    className="input-control" 
                                    type="text" 
                                    {...register("username")} 
                                    placeholder="Tên người dùng" 
                                />
                                {errors.username && <div className="error-msg">{errors.username.message}</div>}
                            </div>

                            <div className="input-row">
                                <input 
                                    className="input-control" 
                                    type={showPassword ? "text" : "password"} 
                                    {...register("password")} 
                                    placeholder="Mật khẩu" 
                                />
                                <div className="eye-btn" onClick={toggleShowPassword}>
                                    {showPassword ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                                </div>
                                {errors.password && <div className="error-msg">{errors.password.message}</div>}
                            </div>

                            <div className="remember-row">
                                <label className="remember-me">
                                    <input type="checkbox" />
                                    <span>Lưu</span>
                                </label>
                            </div>

                            {err && <div className="error-msg" style={{ textAlign: "center", marginBottom: "12px" }}>{err}</div>}

                            {/* 2. Nhóm chứa nút Đăng Nhập và nút Đăng Ký */}
                            <div className="action-buttons">
                                <button className="btn-submit" type="submit">Đăng nhập</button>
                                
                                {/* Nút Đăng Ký - type="button" để không submit form, sử dụng navigate trỏ về /register */}
                               <div className="login-link">
                                Quý khách chưa có tài khoản <span onClick={() => navigate("/register")}>Đăng ký</span>
                            </div>
                            </div>
                            
                        </form>

                        <img 
                            src="https://i.ibb.co/FFk94XB/image.png" 
                            alt="1.1.1.1 Banner" 
                            className="banner-1111" 
                            onClick={() => window.open('https://1.1.1.1/', '_blank')}
                        />

                    </div>
                </div>
            </div>
        </>
    );
}

export default Login;